import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Fade from 'react-reveal/Fade';
import { translate } from 'react-i18next';
import Map from '../../../components/Map';
import { Button, LinkBadge } from '../../Button';
import Collection from '../../Collection';
import Icon from '../../Icon';
import styled from 'styled-components';
import {
  CollectionWrapper,
  Content,
  Header,
  MapWrapper,
  DIV,
  Root,
  Title,
  TitleWrapper,
  BadgeWrapper
} from './styles';
import Badge from '../../Badge';
import routes from '../../../../conf/routes';

import { Link } from '../../../../routes';
import Text from '../../Typography/Text';
import theme from '../../../theme';
import OpeningBadge from '../../Badge/OpeningBadge';
import IconSVG from '../../Icon/IconSVG';
import { media } from '../../../styles/media';

const PhoneWrapper = styled.a`
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  text-decoration: none;
`;

const Phone = styled.p`
  font-family: ${props => props.theme.font.brand.secondary};
  font-size: 18px;
  line-height: 25.2px;
  color: ${props => props.theme.color.brand.white};
`;

const PhoneIcon = styled.div`
  box-sizing: border-box;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${props => props.theme.color.brand.accent};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
`;

const PlanTitle = styled.div`
  display: flex;
  justify-content: center;

  ${media.tablet`
    justify-content: start;
  `};
`;

class InfoBanner extends PureComponent {
  render() {
    const {
      name,
      place,
      tel,
      mail,
      content,
      hours,
      t,
      i18n,
      ctaLabel
    } = this.props;

    return (
      <Fade up>
        <Root>
          <Header>
            <BadgeWrapper>
              <OpeningBadge hours={hours} size={160} />
            </BadgeWrapper>
            <Text
              variant="heading3"
              color={theme.color.brand.white}
              as="h3"
              marginBottom="10px"
            >
              {t('common:brands.schedule')}
            </Text>
            {content && <DIV dangerouslySetInnerHTML={{ __html: content }} />}
            <Text
              variant="body2"
              as="p"
              color={theme.color.brand.white}
              marginBottom="10px"
              marginTop="10px"
            >
              {t('common:brands.place')} : {place.name}
            </Text>
            {tel && (
              <PhoneWrapper href={`tel:${tel}`}>
                <PhoneIcon>
                  <IconSVG name="phone" color="white" />
                </PhoneIcon>
                <Phone>{tel}</Phone>
              </PhoneWrapper>
            )}
            {mail.trim() && (
              <Button
                iconType="arrowTopRight"
                href={`mailto:${mail.trim()}`}
                textColor={theme.color.brand.white}
              >
                {ctaLabel}
              </Button>
            )}
          </Header>
          <Content>
            <TitleWrapper>
              <PlanTitle>
                <Text
                  variant="heading3"
                  as="h4"
                  color={theme.color.brand.accent}
                >
                  {t('common:brands.plan.title')}
                </Text>
              </PlanTitle>
              <Button href={routes.map.langs[i18n.language]}>
                {t('common:brands.plan.button')}
              </Button>
            </TitleWrapper>
            <MapWrapper>
              <Map readOnly selected={place} />
            </MapWrapper>
          </Content>
        </Root>
      </Fade>
    );
  }
}

InfoBanner.propTypes = {
  place: PropTypes.object,
  type: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  hours: PropTypes.object,
  tel: PropTypes.string,
  mail: PropTypes.string,
  content: PropTypes.string,
  ctaLabel: PropTypes.string,
  t: PropTypes.func,
  i18n: PropTypes.object
};

export default translate()(InfoBanner);
